export const StripUnit = (value1: string, value2: string) => {
  const strippedValue1 = parseInt(value1, 10);
  const strippedValue2 = parseInt(value2, 10);
  const sum = strippedValue1 - strippedValue2;
  return sum;
};

export function FluidType(
  minFontSize: any,
  maxFontSize: any,
  minWidth: any,
  maxWidth: any
) {
  return `
    @media screen and (min-width: ${minWidth}) {
      font-size: calc(${minFontSize} + ${StripUnit(
    maxFontSize,
    minFontSize
  )} * ((100vw - ${minWidth}) / ${StripUnit(maxWidth, minWidth)}));
    }
    @media screen and (min-width: ${maxWidth}) {
      font-size: ${maxFontSize};
    }
    `;
}



// WEBPACK FOOTER //
// ./src/Components/Text/FluidType.tsx